import { Component } from 'preact'
import { StateAwareHeaderComponentProps } from '@insided/deprecated-control/overview'
import { UserData } from '@insided/deprecated-control/UserOverview/DataSource'
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import { CustomProfileFieldList } from '@insided/deprecated-control/UserOverview/Columns'
import SaveSegmentModal from './SaveSegmentModal'
import { saveSegment } from './api'

interface HeaderActionsComponentProps extends StateAwareHeaderComponentProps<UserData> {
  customProfileFields: CustomProfileFieldList
}

interface State {
  showSaveModal: boolean
  isSavingSegment: boolean
  showErrorMessage: boolean
}

class HeaderActionsComponent extends Component<HeaderActionsComponentProps, State> {
  constructor(props: HeaderActionsComponentProps) {
    super(props)

    this.state = {
      showSaveModal: false,
      isSavingSegment: false,
      showErrorMessage: false
    }
  }

  showSaveModal = () => this.setState({ showSaveModal: true })

  hideSaveModal = () => this.setState({ showSaveModal: false })

  onSave = async (title: string, description: string) => {
    const { isSavingSegment } = this.state
    if (isSavingSegment) {
      return
    }

    this.setState({
      isSavingSegment: true,
      showErrorMessage: false
    })

    const { filters = {}, customProfileFields } = this.props
    try {
      await saveSegment(title, description, filters, customProfileFields)

      window.location.assign('/users/segments?showMessage=success')
    } catch (err) {
      this.setState({
        isSavingSegment: false,
        showErrorMessage: true
      })
    }
  }

  render() {
    const { areFiltersApplied } = this.props
    if (!areFiltersApplied) {
      return null
    }

    const { showSaveModal, isSavingSegment, showErrorMessage } = this.state

    return (
      <div>
        <ButtonControl
          onClick={this.showSaveModal}
          title='Save as segment'
          variant='success'
          newStyle
          size='medium'
        />
        <SaveSegmentModal
          onClose={this.hideSaveModal}
          onSave={this.onSave}
          showModal={showSaveModal}
          isSubmitting={isSavingSegment}
          showGenericError={showErrorMessage}
        />
      </div>
    )
  }
}

export default HeaderActionsComponent
